import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { Clase } from 'src/app/Models/clase/clase';
import { DataService } from 'src/app/Service/data.service';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { isEmptyExpression } from '@angular/compiler';

@Component({
    selector: 'app-clase',
    templateUrl: './clase.component.html'
})
export class ClaseComponent implements OnInit {
    @ViewChild('btnshow', null) btnshow: ElementRef;
    @ViewChild('btnclose', null) btnclose: ElementRef;
    @ViewChild('txtfirt', null) txtfirt: ElementRef;
    
    @ViewChild(AlertComponent, null) alert: AlertComponent;
    @ViewChild(LoadingComponent, null) loading: LoadingComponent;
    @ViewChild(InfoComponent, null) info: InfoComponent;
    public isShow: boolean = false;
    public pagina: number = 0;
    public clases: Clase[] = [];
    public claseres:Clase = new Clase();
    public clase: Clase = new Clase();
    public isEdit: boolean = false;
    public funcion: Function = null;
    public pagclasse: any;
    public total:number=0;
    public adddescripcion: boolean = false;
    public search = '';
    public modal="";
    public showdelete:boolean = false;
    public usuario:Usuario= new Usuario();
    public zindex:number = 10000;
    constructor(private data: DataService) { }

    ngOnInit() {
    }

    public show(affterfunction: Function = null) {
        this.funcion = affterfunction;
        this.isShow = true;
        this.showTab(1);
        this.showdelete=false;
        setTimeout(() => {
            this.btnshow.nativeElement.click();
            this.info.hide();
            this.usuario = this.data.getCurrentUser();
            console.log(this.usuario);
            this.GetData();
        }, 10);
    }

    GetData() {
        this.loading.show("cargando..");
        this.clases=[];
        let send;

        this.data.Exists(this.search)?
        send = this.data.GetFromValue(this.data.api.clase, 'like', this.search):
        send = this.data.GetSimple(this.data.api.clase)
        
        send.subscribe(r => {
            this.loading.hide();
            if (r.length>0) { this.clases = r; this.total = this.clases.length; }
        }, e => { this.loading.hide(); this.info.error(e, () => { this.showTab(1) }) })
    }
    ShowInfoItem(i){
        this.clase = i as Clase;
        this.showTab(3);
    }
    ShowNewItem() {
        this.isEdit = false;
        this.showTab(2);
        this.clase = new Clase();
        this.adddescripcion = false;
        setTimeout(() => { this.txtfirt.nativeElement.focus(); }, 10);
    }
    ShowEditItem(i) {
        this.isEdit = true;
        this.showTab(2);
        this.clase = i as Clase;
        // if(this.nacionalidad.descripcion != ""){this.adddescripcion = true;}else{this.adddescripcion = false;}
        setTimeout(() => { this.txtfirt.nativeElement.focus();  }, 10);
    }
    ShowDeleteItem(i){
        this.clase = i as Clase;
        this.modal='';
        this.showdelete= true;
        this.info.show("¿Estimado usuario(a) deseas Quitar/Eliminar el elemento [nombre:\""+this.clase.nombre+"\"] del sistema? ",1,null,{ cancelText: 'No, Cancelar', successText: 'Si, Continuar', isCancel: true },()=>{this.Delete();},()=>{this.showTab(1); this.modal='modal-lg'; this.showdelete=false; this.info.hide();},20);
    }

    Delete(){
        this.loading.show('eliminando elemento');
        this.data.Delete(this.data.api.clase,this.clase.idclase).subscribe(r=>{
            this.loading.hide();
            this.info.show(r.message, 2 ,null,null,()=>{this.info.hide(); this.modal='modal-lg'; this.showdelete=false;});
            if(r.status == 'success') { this.GetData();}
        },e=>{this.info.error(e.error.text,()=>{this.info.hide(); this.modal='modal-lg'; this.showdelete=false;});})
    }

    showTab(i) {

        this.pagina = i;
        if(this.pagina == 1){this.modal ='modal-lg';}
        else{this.modal='';}
    }

    close() {
        this.btnclose.nativeElement.click();
        setTimeout(() => { this.isShow=false; }, 1000);
        setTimeout(() => {if (this.funcion != null) { this.funcion(); } }, 10);
    }

    Save() {
        if (this.isEdit) {
            this.loading.show("Actualizando..");
            this.clase.usuario_id = this.data.getCurrentUser().id;
            this.data.Put(this.data.api.clase, this.clase.idclase, this.clase).subscribe(r => {
                //this.claseres=r;
                this.loading.hide();
                this.info.show(r.message, 2, null, null, () => { this.showTab(r.status == 'success' ? 1 : 2); setTimeout(() => { this.GetData(); }, 5); });
            }, e => { this.loading.hide(); this.info.error(e, () => { this.showTab(2) }) })
        }
        else {
            this.loading.show("Registrando..");
            this.clase.usuario_id = this.data.getCurrentUser().id;
            this.data.Post(this.data.api.clase, this.clase).subscribe(r => {
                this.claseres=r.data;
                this.loading.hide();
                this.info.show(r.message, 2, null, null, () => { this.showTab(r.status == 'success' ? 1 : 2); setTimeout(() => { this.GetData(); }, 5); });
            }, e => { this.loading.hide(); this.info.error(e, () => { this.showTab(2) }) })
        }
        if (this.funcion != null) {
            this.funcion();
        }
    }
}
